import type { IconSvgObject } from './types';

const HtmlFile02Icon: IconSvgObject = [
  ["path", { d: "M5 14V16.5M5 19V16.5M8 14V16.5M8 19V16.5M5 16.5H8M10 14H11.25M12.5 14H11.25M11.25 14V19M14.5 19V14L16.25 16.5L18 14V19M20 14V19H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 11V9L11 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 2V7C11 8.10457 11.8954 9 13 9H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HtmlFile02Icon;
